import { defineComponent, inject, reactive, ref, computed } from 'vue';
import { ArrowRight, Close } from '@element-plus/icons-vue';
import { ElPopover, ElIcon } from 'element-plus';
export default defineComponent({
  components: {
    ElPopover,
    ElIcon,
    ArrowRight,
    Close
  },
  props: {
    total: Number,
    activeTab: Number || String,
    highSetting: Array
  },
  setup(props, context) {
    const $http = inject('$http');
    const $utils = inject('$utils');
    const filterArr = ref([]);
    const handleData = () => {
      let filter = props.highSetting.find(item => item.key_str == 'query_filter').value_str;
      filterArr.value = filter.split(',');
    };
    handleData();

    // 获取思政元素
    const ideologyList = ref([]);
    const getIdeology = async () => {
      let res = await $http.getIdeologyList();
      console.log('思政元素', res);
      ideologyList.value = res;
    };
    getIdeology();

    // 所属机构
    const collegeList = ref([]);
    async function getOrganTreeList() {
      const dataStatus = props.highSetting.find(item => item.key_str === 'get_data').value_str;
      let res = await $http.getCaseFilterOrgTree({
        business_type: props.activeTab,
        dataStatus
      });
      collegeList.value = res;
      console.log(collegeList.value);
    }
    getOrganTreeList();

    // 适用专业
    const majorList = ref([]);
    async function getMajorList() {
      let res = await $http.getCaseMajorList();
      majorList.value = res;
    }
    getMajorList();

    // 课程类型
    const courseTypeList = ref([]);
    async function getCourseTypeList() {
      let res = await $http.getCourseTypeList();
      console.log('课程类型', res);
      courseTypeList.value = res;
      courseTypeList.value.unshift({
        id: '-1',
        dict_name: '全部'
      });
    }
    getCourseTypeList();
    const isshowAllIde = ref(false);
    const isShowAllCollege = ref(false);
    const isShowAllMajor = ref(false);
    const isShowAllType = ref(false);
    const colorList = ref(['#E9C995', '#DC8571', '#E1A584', '#9CACC7', '#A499BC', '#B1DAEB', '#A5D6C2', '#F6AEAE', '#AABDEF', '#A7E396']);
    const showIdeologyList = computed(() => {
      if (isshowAllIde.value || ideologyList.value.length < 5) {
        return ideologyList.value;
      } else {
        return ideologyList.value.slice(0, 5);
      }
    });
    const formatColor = index => {
      if (colorList.value[index]) {
        return colorList.value[index];
      } else {
        return colorList.value[index % colorList.value.length];
      }
    };
    const curIdeolog = ref({});
    function chooseIdeolog(id, ideologyName) {
      curIdeolog.value = {
        id,
        ideologyName
      };
      context.emit('ideologChange', id);
    }
    const curCollege = ref({
      id: '-1',
      organName: '全部'
    });
    function chooseCollege(id, organName) {
      curCollege.value = {
        id,
        organName
      };
      context.emit('collegeChange', id);
    }
    const curMajor = ref({
      id: '-1',
      majorName: '全部'
    });
    function chooseMajor(id, majorName, fatherId) {
      // 当传入专业id时 major_flag为1 否则为2
      let params = {
        id,
        major_flag: id != fatherId ? 1 : 2
      };
      curMajor.value = {
        id,
        majorName
      };
      context.emit('majorChange', params);
    }
    const curType = ref({
      id: '-1',
      dict_name: '全部'
    });
    function chooseType(id, typeName) {
      curType.value = {
        id,
        dict_name: typeName
      };
      context.emit('typeChange', id);
    }
    function delIdeolog() {
      curIdeolog.value = {};
      context.emit('ideologChange', '');
    }
    function delCollege() {
      curCollege.value = {};
      context.emit('collegeChange', '');
    }
    function delMajor() {
      curMajor.value = {};
      context.emit('majorChange', '');
    }
    function delType() {
      curType.value = {};
      context.emit('typeChange', '');
    }
    return {
      filterArr,
      getIdeology,
      courseTypeList,
      ideologyList,
      showIdeologyList,
      collegeList,
      majorList,
      colorList,
      curIdeolog,
      curCollege,
      curMajor,
      curType,
      isshowAllIde,
      isShowAllCollege,
      isShowAllMajor,
      isShowAllType,
      getOrganTreeList,
      getMajorList,
      chooseIdeolog,
      delIdeolog,
      chooseCollege,
      chooseMajor,
      chooseType,
      delCollege,
      delMajor,
      delType,
      formatColor
    };
  }
});